import { Grid, IconButton, Typography } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { formatCurrency } from "../../../../Utils/formatters";
import Tooltip from "../../../../Components/Atoms/Tooltip";

type Props = {
  title: string;
  amount: number;
  name?: string;
};

export const SaldoCard = ({ title, amount }: Props) => {
  return (
    <Grid>
      <Grid>
        <Typography lineHeight={"3em"} color="#5B6B79" fontWeight={400} marginTop={1}>
          {title}
        </Typography>
      </Grid>
      <Grid>
        <Typography fontSize="3em" alignItems="center">
          {formatCurrency(amount)}{" "}
          <Tooltip title="Atualizar saldo do ponto de venda">
            <span>
              <IconButton size="large" color="primary" onClick={() => window.dispatchEvent(new Event("refresh-balance"))}>
                <CachedIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SaldoCard;
